import React, { PropsWithChildren } from 'react'
import { useLocation } from 'react-router-dom'
interface ModalProps {
  isModal: boolean
}

export const Modal = ({ children, isModal }: PropsWithChildren<ModalProps>) => {
  const { pathname } = useLocation()
  if (!isModal || pathname === '/shortform-price-guide') return null
  return (
    <div className="fixed left-0 top-0 z-50 flex h-full w-full flex-col items-center justify-center bg-black bg-opacity-50 text-center md:h-screen">
      {children}
    </div>
  )
}
